import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'roles',
    pluginName: 'ROLE',
    entityName: 'ROLE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch Role action creators
export const fetchRoleInit = () => { return crudActions.fetchInit(); }
export const fetchRoleStart = () => { return crudActions.fetchStart(); }
export const fetchRoleSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchRoleFail = () => { return crudActions.fetchFail(); }

export const fetchRolesCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchRoleStart());
        try {
            let countRes = await rest.post("roles/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchRoleSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchRoleFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch roles."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchRoleFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch roles."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchRoles = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchRoleStart());
        try {
            let listRes = await rest.post("roles/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchRoleSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchRoleFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchRoleFail());

            return { data: [] };
        }
    }
};
// Create Role  action creators
export const createRoleInit = () => { return crudActions.createInit(); };
export const createRoleStart = () => { return crudActions.createStart(); };
export const createRoleSuccess = createdRole => { return crudActions.createSuccess(createdRole); };
export const createRoleFail = error => { return crudActions.createFail(error); };
export const createRole = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createRoleStart());
        try {
            let res = await rest.post('/roles/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created role.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createRoleFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create role."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create role."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createRoleFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete Role  action creators
export const bulkDeleteRoleInit = () => { return crudActions.bulkDeleteInit(); };
export const bulkDeleteRoleStart = () => { return crudActions.bulkDeleteStart(); };
export const bulkDeleteRoleSuccess = bulkDeleted => { return crudActions.bulkDeleteSuccess(bulkDeleted); };
export const bulkDeleteRoleFail = error => { return crudActions.bulkDeleteFail(error); };
export const bulkDeleteRole = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteRoleStart());
        try {
            let res = await rest.post('/roles/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteRoleSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted roles.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteRoleFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete roles."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete roles."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteRoleFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit role  action creators
export const editRoleInit = () => { return crudActions.editInit(); };
export const editRoleStart = () => { return crudActions.editStart(); };
export const editRoleSuccess = editedRole => { return crudActions.editSuccess(editedRole); };
export const editRoleFail = error => { return crudActions.editFail(error); };

export const editRole = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editRoleStart());
        try {
            let res = await rest.post('/roles/save', params);
            if (res.data && res.data.succeeded) {
                // dispatch(editRoleSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated role.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editRoleFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit role."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit role."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editRoleFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load role action creators
export const loadRoleInit = () => { return crudActions.loadInit(); };
export const loadRoleStart = () => { return crudActions.loadStart(); };
export const loadRoleSuccess = loadedRole => { return crudActions.loadSuccess(loadedRole); };
export const loadRoleFail = error => { return crudActions.loadFail(error); };
export const loadRole = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

export const loadPermission = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/permissions/list', { listAll: true, ...data }, options);
            if (res.data && res.data.succeeded) {
                let permissions = [];
                for (var permission of res.data.result.data) {
                    permissions.push({ value: permission.PermissionID, label: `${permission.Name}` });
                }
                return permissions;
            } else {
                if (res && res.canceled) {
                    return [];
                }

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list permissions"}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}
